module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "Social-links-form modal-card",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addLinks($event)
      }
    }
  }, [_c('button', {
    staticClass: "delete is-medium",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card-body"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.link_types.length),
      expression: "link_types.length"
    }],
    staticClass: "title is-size-6-touch"
  }, [_vm._v(_vm._s(_vm.$t('social_link_form.title')))]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.link_types.length),
      expression: "!link_types.length"
    }],
    staticClass: "title is-size-6-touch"
  }, [_vm._v(_vm._s(_vm.$t('social_link_form.title_empty')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.not_enough),
      expression: "not_enough"
    }],
    staticClass: "notification is-info"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('social_link_form.not_enough', {
    nb: 2
  })) + "\n    ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._v(_vm._s(_vm.$t('loading')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.link_types), function(type) {
    return _c('div', {
      key: type,
      staticClass: "column is-half"
    }, [_c('p', {
      staticClass: "control has-icon"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.links[type]),
        expression: "links[type]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": type == 'other' ? _vm.$t('social_link_form.type_other') : type
      },
      domProps: {
        "value": (_vm.links[type])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.links, type, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa",
      class: 'fa-' + (type == 'other' ? 'link' : type)
    })])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.links[type].$error && !_vm.$v.links[type].matchRegexp),
        expression: "$v.links[type].$error && !$v.links[type].matchRegexp"
      }],
      staticClass: "help is-danger",
      domProps: {
        "innerHTML": _vm._s(_vm.$t('validation.active_url'))
      }
    })])
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.not_enough),
      expression: "not_enough"
    }],
    staticClass: "notification is-info"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('social_link_form.not_enough', {
    nb: 2
  })) + "\n    ")])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.link_types.length),
      expression: "!loading && link_types.length"
    }]
  }, [_c('button', {
    staticClass: "button is-danger",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.add_links')) + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "Social-links-form_img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/pop_illustration_social.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea1c0e0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalSocialLinks.vue
// module id = 368
// module chunks = 9